// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SECTION_SELECTOR = '.search-results-list';
var CAROUSEL_SELECTOR = '.carousel--search-results-list';
var CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';
var swiperInstances = new Map();
var destroyCarousel = carousel => {
  var instance = swiperInstances.get(carousel);
  if (!instance) {
    return;
  }
  instance.focusHandlers.forEach(_ref => {
    var slideLink = _ref.slideLink,
      handler = _ref.handler;
    slideLink.removeEventListener('focus', handler);
  });
  instance.swiper.destroy(true, true);
  swiperInstances.delete(carousel);
};
var initCarousel = section => {
  var carousel = section.querySelector(CAROUSEL_SELECTOR);
  var scrollbar = section.querySelector(CAROUSEL_SCROLLBAR_SELECTOR);
  if (!carousel || !scrollbar) {
    return;
  }

  // Tear down any existing swiper before re-creating it.
  destroyCarousel(carousel);
  console.log(carousel);
  var swiper = new Swiper(carousel, {
    modules: [Scrollbar, A11y, Keyboard],
    slidesPerView: 2.1,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: true,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    breakpoints: {
      768: {
        slidesPerView: 4
      }
    },
    scrollbar: {
      el: scrollbar,
      hide: false,
      draggable: true
    }
  });
  console.log(swiper);
  var focusHandlers = [];
  swiper.slides.forEach((slide, index) => {
    var slideLink = slide.querySelector('a');
    if (!slideLink) {
      return;
    }
    var handler = () => swiper.slideTo(index);
    slideLink.addEventListener('focus', handler);
    focusHandlers.push({
      slideLink,
      handler
    });
  });
  swiperInstances.set(carousel, {
    swiper,
    focusHandlers
  });
};
var refreshCarousels = () => {
  swiperInstances.forEach((_value, carousel) => {
    destroyCarousel(carousel);
  });
  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach(section => initCarousel(section));
};
var onContentReady = () => {
  refreshCarousels();
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onContentReady);
} else {
  onContentReady();
}
document.addEventListener('predictive_search.performed', onContentReady);